import PaginatedGridGallery_PaginatedGridRibbonArrowsComponent from '../components/NativeGalleries/PaginatedGridGallery/viewer/skinComps/PaginatedGridRibbonArrows/PaginatedGridRibbonArrows.skin';
import PaginatedGridGallery_PaginatedGridRibbonArrowsController from '../components/NativeGalleries/PaginatedGridGallery/viewer/PaginatedGridGallery.controller';


const PaginatedGridGallery_PaginatedGridRibbonArrows = {
  component: PaginatedGridGallery_PaginatedGridRibbonArrowsComponent,
  controller: PaginatedGridGallery_PaginatedGridRibbonArrowsController
};


export const components = {
  ['PaginatedGridGallery_PaginatedGridRibbonArrows']: PaginatedGridGallery_PaginatedGridRibbonArrows
};

